import { useEffect, useState } from 'react';

// Success feedback is brief and non-blocking. Errors remain persistent in-page.
export default function StatusToast({ message }) {
  const [dismissedMessage, setDismissedMessage] = useState(null);

  useEffect(() => {
    if (!message) {
      setDismissedMessage(null);
      return undefined;
    }
    const timeout = window.setTimeout(() => setDismissedMessage(message), 4000);
    return () => window.clearTimeout(timeout);
  }, [message]);

  // Make new feedback visible on the very first render, without waiting for an effect.
  if (!message || message === dismissedMessage) return null;

  return (
    <div className="bo-toast" role="status" aria-live="polite">
      <span className="bo-toast__icon" aria-hidden="true">✓</span>
      <span className="bo-toast__message">{message}</span>
      <button type="button" className="bo-toast__close"
        onClick={() => setDismissedMessage(message)}
        aria-label="Fermer la notification" title="Fermer la notification">
        ×
      </button>
    </div>
  );
}
